<template>
  <div class="otherInfo" >
    <div v-show="$route.meta.activeSubName">
      <router-view></router-view>
    </div>
    <div v-show="!$route.meta.activeSubName">
      <div class="container"
           v-loading="loading"
           element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="#F6F6F6">
        <div v-for="item in list"
             :key="item.id"
             @click="location(item)"
             class="itemStyle">
          <div class="itemImg">
            <img v-lazy="'http://file.hoaccu.com/' + item.coverImg" :alt="item.coverImg">
          </div>
          <div class="itemTitle">
            {{item.title}}
          </div>
        </div>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout=" prev, pager, next,total"
        class="pagination"
        :total="pageNum">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {
    getCompanyOtherInfo
  } from "@/api/hoaccu";

  export default {
    name: "otherInfo",
    data() {
      return {
        list: [],
        loading: false,
        currentPage:1,
        pageSize:9,
        pageNum:0,
        parentName:""
      }
    },
    created() {

    },
    methods: {
      location(row){
        this.$router.push({
          name:this.parentName + "详情",
          params:{
            id:row.id
          }
        })
      },
      refreshInfo(){
        this.loading = true;
        let path = this.$route.path.split("/")[this.$route.path.split("/").length - 1];
        getCompanyOtherInfo({
          page: this.currentPage,
          pageSize: this.pageSize,
          condition: [
            {
              "key": "type",
              "value": path
            }
          ]
        }).then(res => {
          if (res.status === 200) {
            this.list = res.data.data;
            this.pageNum = res.data.count;
            this.loading = false;
          } else {
            this.$message.warning(res.message);
            this.content = "暂无数据";
            this.loading = false;
          }
        }).catch(err => {
          this.$message.warning(err.message);
          this.content = "暂无数据";
          this.loading = false;
        })
      },
      //当前页的切换
      handleCurrentChange(val) {
        this.currentPage = val;
        this.refreshInfo();
      },
      //每页数量的切换
      handleSizeChange(val) {
        this.pageSize = val;
        this.refreshInfo();
      }
    },
    watch: {
      $route: {
        deep: true,
        immediate: true,
        handler() {
          this.parentName = this.$route.name;
          this.currentPage = 1;
          this.pageSize = 9;
          this.refreshInfo();
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .otherInfo {
    padding: 10px 0;

    .container{
      min-height: 70vh;
      display: flex;
      flex-wrap: wrap;
      .itemStyle{
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 20px;
        width: 285px;
        cursor: pointer;
        &:hover .itemTitle{
          text-decoration: underline;
        }
        .itemImg{
          border: 1px solid #ccc;
          width: 100%;
          text-align: center;
          &>img{
            width: 100%;
            height: 175px;
          }
          &>img[lazy="loading"]{
            display:block;
            width:50px !important;
            height:50px !important;
            margin:60px auto;
          }
        }
        .itemTitle{
          margin-top: 10px;
          text-align: center;
          user-select: none;
        }
      }
    }

    /deep/.el-pager li,/deep/.el-pagination button:disabled,/deep/.el-pagination .btn-next, /deep/.el-pagination .btn-prev{
      background: none;
    }

    .pagination{
      margin-top: 30px;
      text-align: center;
    }

  }
</style>
